(function () {
	const SELECTOR = '.wp-block-term-description';
	const EXPANDED_CLASS = 'is-expanded';
	const HIDDEN_CLASS = 'd-none';
	let initialized = false;

	function init() {
		if (initialized) return;

		const container = document.querySelector(SELECTOR);
		if (!container) return;

		// Links are rendered server-side, find them
		const readMore = container.nextElementSibling;
		const readLess = readMore?.nextElementSibling;

		if (!readMore?.classList.contains('read-more') || !readLess?.classList.contains('read-less')) {
			return;
		}

		initialized = true;

		// Check if content is actually truncated (scrollHeight > clientHeight)
		if (container.scrollHeight <= container.clientHeight) {
			// Content fits within 2 lines, hide read more link
			readMore.classList.add(HIDDEN_CLASS);
			return;
		}

		// Event handlers
		readMore.addEventListener('click', (e) => {
			e.preventDefault();
			container.classList.add(EXPANDED_CLASS);
			readMore.classList.add(HIDDEN_CLASS);
			readLess.classList.remove(HIDDEN_CLASS);
		});

		readLess.addEventListener('click', (e) => {
			e.preventDefault();
			container.classList.remove(EXPANDED_CLASS);
			readMore.classList.remove(HIDDEN_CLASS);
			readLess.classList.add(HIDDEN_CLASS);
		});
	}

	// Retry until block exists (FSE safe)
	document.addEventListener('DOMContentLoaded', () => {
		init();
		const interval = setInterval(() => {
			if (initialized) {
				clearInterval(interval);
			} else {
				init();
			}
		}, 100);
	});
})();